import { jsxs as o, jsx as l } from "react/jsx-runtime";
const h = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...r,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M34.96 28.449 32 23.265l-2.96 5.184-6.245 1.745 4.416 3.79-1.131 6.099L32 37.378l5.92 2.705-1.13-6.099 4.416-3.788-6.246-1.747Zm.527 4.018-.874.75.21 1.132.43 2.316-2.422-1.106-.831-.38-.831.38-2.421 1.106.43-2.316.209-1.132-.874-.75-1.577-1.354 2.642-.738.791-.22.408-.714L32 27.298l1.223 2.143.407.713.791.221 2.643.739-1.577 1.353ZM43.702 49.834h-.003l.002.007v-.007Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M54.62 28.52 58 15.682l-17.647-4.729-8.311.009-8.311-.009-17.647 4.729 3.461 12.894 7.837-2.179v23.488a2.956 2.956 0 0 0 2.956 2.956h24.167l-.804-3H20.382V22.45l-3.804 1.057-4.92 1.368-1.899-7.072 13.47-3.61c.911 3.846 4.373 6.715 8.493 6.715 4.177 0 7.678-2.95 8.53-6.876l14.086 3.775-1.852 7.035-5.008-1.342-3.776-1.013v27.347l3-.804V26.397l7.918 2.123ZM31.722 17.908a5.737 5.737 0 0 1-5.445-3.952l5.762.006h.006l5.121-.005a5.737 5.737 0 0 1-5.444 3.95Z"
        }
      )
    ]
  }
);
export {
  h as Merch
};
